import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { tokens } from '../../../design';

/**
 * Detail-drawer footer (AUT-124): the suspend / reactivate action + audit
 * note. The action itself is role + permission + audit gated server-side —
 * this is presentation only.
 */
export const UserDetailFooter = ({
  suspended,
  busy,
  onSuspend,
  onReactivate,
}: {
  suspended: boolean;
  busy: boolean;
  onSuspend: () => void;
  onReactivate: () => void;
}): ReactElement => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.25,
        p: '14px 24px',
        borderTop: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
      }}
    >
      {suspended ? (
        <Button variant="contained" color="success" disabled={busy} onClick={onReactivate}>
          {t('users.actions.reactivate')}
        </Button>
      ) : (
        <Button variant="contained" color="error" disabled={busy} onClick={onSuspend}>
          {t('users.actions.suspend')}
        </Button>
      )}
      <Box
        sx={{
          ml: 'auto',
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.5,
          fontSize: 11,
          color: tokens.text.tertiary,
        }}
      >
        <InfoOutlinedIcon sx={{ fontSize: 12 }} />
        {t('users.actions.auditNote')}
      </Box>
    </Box>
  );
};
